import React from 'react';
import clsx from 'clsx';
import { getDaysInMonth, startOfMonth } from 'date-fns';

import { getDayName, getMonthName } from '@futrli/shared-services';

import { CalendarPanelCell } from './calendar-panel-cell';
import { CalendarPanelValueMap } from './types';
import { COLUMNS, TILE_HEIGHT, TILE_WIDTH } from './constants';
import * as styles from './calendar-panel.scss';

export interface CalendarPanelProps {
  className?: string;
  date: Date;
  style?: React.CSSProperties;
  values?: CalendarPanelValueMap;
}

export const CalendarPanel = ({ className, date, style, values }: CalendarPanelProps) => {
  const title = `${getMonthName(date.getMonth() + 1)} ${date.getFullYear()}`;
  const dayTitles = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  const startDayTitle = getDayName(startOfMonth(date), 'short');
  const spacersRequired = [...new Array(dayTitles.indexOf(startDayTitle))];
  const days = [...new Array(getDaysInMonth(date))].map((item, i) => i + 1);

  return (
    <div className={clsx(className, styles.container)} style={{ ...style, width: COLUMNS * TILE_WIDTH }}>
      <div className={styles.title}>{title}</div>
      <ul className={styles.grid}>
        {dayTitles.map(dayTitle => (
          <li key={dayTitle} className={styles.header} style={{ width: TILE_WIDTH }}>
            {dayTitle}
          </li>
        ))}
        {spacersRequired.map((v, i) => (
          <li key={`spacer-${i}`} className={styles.tile} style={{ height: TILE_HEIGHT, width: TILE_WIDTH }} />
        ))}
        {days.map((dayNum, i) => (
          <CalendarPanelCell key={`day-${i}`} dayNum={dayNum} value={values?.[dayNum]} />
        ))}
      </ul>
    </div>
  );
};
